module.exports = __webpack_public_path__ + "img/emptystate-error.91a11038.svg";